import type { JSX } from 'react';
import { useNavigate } from 'react-router-dom';
import { TableCell } from '@/components/ui/table';
import { ClickableTableRow } from '@/shared/components/ClickableTableRow';
import { ApplicationStatusSelect } from './ApplicationStatusSelect';
import { AppliedCell, CandidateInfoCell, NotesCell, UnlinkCell } from './CandidateRowCells';
import type {
  JobPositionCandidateWithDetails,
  ApplicationStatus,
} from '../../types/jobPositionCandidate.types';

interface CandidateRowProps {
  candidate: JobPositionCandidateWithDetails;
  onStatusChange: (candidateId: string, status: ApplicationStatus) => void;
  onUnlink: (candidateId: string, candidateName: string) => void;
  isUpdating: boolean;
}

export function CandidateRow({
  candidate,
  onStatusChange,
  onUnlink,
  isUpdating,
}: CandidateRowProps): JSX.Element {
  const { candidate: info } = candidate;
  const navigate = useNavigate();

  return (
    <ClickableTableRow
      onActivate={() => navigate(`/candidates/${info.id}`)}
      label={info.name}
      testId={`job-position-candidate-row-${info.id}`}
    >
      <CandidateInfoCell id={info.id} name={info.name} email={info.email} />
      <TableCell>
        <ApplicationStatusSelect
          currentStatus={candidate.applicationStatus}
          onStatusChange={(s) => onStatusChange(info.id, s)}
          disabled={isUpdating}
        />
      </TableCell>
      <AppliedCell appliedAt={candidate.appliedAt} />
      <NotesCell notes={candidate.notes} />
      <UnlinkCell onUnlink={() => onUnlink(info.id, info.name)} />
    </ClickableTableRow>
  );
}
